import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  spaceXXL,
  spaceXL,
  spaceS,
  spaceM,
  cornerRadiusL,
  xdlColorBackgroundTertiary,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${spaceXL};
  border-radius: ${cornerRadiusL};
  color: ${xdlColorTextSecondary};
  background-color: ${xdlColorBackgroundTertiary};

  @media ${mediaConfined} {
    padding: ${spaceXXL};
  }
`;

export const StyledHeadline = styled(Headline)`
  margin: ${spaceM} 0 ${spaceS};
`;
